import type { AnalyticsInternalData } from '@/features/audio-form/data/dto/audio-form-input.ts'

// The backends read the x-internal-data keys in kebab-case.
interface AudioformInternalDataDTO {
  'workflow-name'?: string | undefined
  'module-name'?: string | undefined
  'module-session-id'?: string | undefined
  'workflow-session-id'?: string | undefined
}

export const mapAudioformInternalData = (
  internalData?: AnalyticsInternalData
): AudioformInternalDataDTO | undefined => {
  if (internalData) {
    return {
      'workflow-name': internalData.workflowName,
      'module-name': internalData.moduleName,
      'module-session-id': internalData.sessionId,
      'workflow-session-id': internalData.sessionId,
    }
  }
}
